import React from "react";
import { ArrowUpRight, ArrowDownRight } from "lucide-react";

/* =======================
   Styles
======================= */
import styles from "./StatsCard.module.scss";

export default function StatsCard({
  title,
  value,
  icon,
  validationMsg,
  negative,
  iconImg, // Retained for compatibility if used elsewhere
}) {
  // Extract number to determine trend direction
  const number = parseFloat(validationMsg);
  const isNegative = negative || number < 0;

  // Ensure proper formatting for the validation message
  const formattedMsg = validationMsg?.startsWith("-")
    ? validationMsg
    : validationMsg?.startsWith("+")
      ? validationMsg
      : `+${validationMsg}`;

  return (
    <div className={styles["stats-card"]}>
      <div className={styles["stats-card__top"]}>
        <div className={styles["stats-card__text"]}>
          <h4 className={styles["stats-card__title"]}>{title}</h4>
          <h2 className={styles["stats-card__value"]}>{value}</h2>
        </div>

        {/* Directly rendering the Lucide React node passed from AdminDashboard */}
        <div className={styles["stats-card__icon-wrapper"]}>{icon}</div>
      </div>

      <div
        className={`${styles["stats-card__trend"]} ${
          isNegative
            ? styles["stats-card__trend--negative"]
            : styles["stats-card__trend--positive"]
        }`}
      >
        <span className={styles["stats-card__trend-icon"]}>
          {isNegative ? (
            <ArrowDownRight size={16} strokeWidth={2.5} />
          ) : (
            <ArrowUpRight size={16} strokeWidth={2.5} />
          )}
        </span>
        <span>{formattedMsg}</span>
      </div>
    </div>
  );
}
